import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateTopic } from "src/modules/book/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createTopic } = props;
    const router = useRouter();
    const { chapter_id } = router.query;

    const onFinish = async (values: any) => {
        await createTopic(values);
        router.push(`/book/topic/${chapter_id}`);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateTopic)(Create);
